import { Component, Input } from '@angular/core';
import { CookieConsentService } from '../../../services/cookie-consent.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  @Input() title: string = '';
  currentYear: number = new Date().getFullYear();

  constructor(private cookieConsentService: CookieConsentService) {}

  openCookiePreferences(): void {
    this.cookieConsentService.openModal();
  }
}
